/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import TextTruncate from "react-text-truncate";
import { jsx, css } from "@emotion/core";

import { primary_s5_l90, primary_light } from "../../../shared/lib/colors";

import A from "../../../shared/Anchor/Anchor";
import Link from "../../../shared/Link/Link";
import Button from "../../../shared/Button/Button";

import "./Magazine.scss";
import { FaChevronRight } from "react-icons/fa";

class Magazine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPost: {
        id: null,
        imgUrl: null,
      },
    };
  }

  componentWillReceiveProps() {
    this.props.posts[0] &&
      this.setState({
        selectedPost: {
          id: this.props.posts[0].id,
          imgUrl: this.props.posts[0].featuredImageUrl,
        },
      });
  }

  setSelectedPost = (post) => (event) => {
    this.setState({
      selectedPost: { id: post.id, imgUrl: post.featuredImageUrl },
    });
  };

  render() {
    const { posts, primaryColor, uiVariantBlogNewsletter } = this.props;
    const { selectedPost } = this.state;

    const magazineStyle = css`
      &.variant-1 {
        .magazine-box {
          background-color: #fff;
          border-radius: 12px;

          .post-image {
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;

            @media (min-width: 567px) {
              border-top-left-radius: 0;
              border-bottom-right-radius: 12px;
            }
          }

          .post-list {
            padding: 30px 43px 20px 20px;
            border-top: 2px;
            border-color: ${primaryColor};

            @media (min-width: 567px) {
              padding: 30px 43px 30px 20px;
              width: 50%;
            }

            .post-title {
              margin: 0 0 20px 10px;
              padding-left: 10px;
              color: #aaa;
              border-left: 3px solid transparent;

              &:last-of-type {
                margin-bottom: 0;
              }

              &:focus,
              &:hover,
              &.active {
                color: #4f4f4f;
                border: 0;
                border-left: 3px solid ${primaryColor}!important;
                border-radius: 0px;
              }
            }
          }
        }
      }

      &.variant-2 {
        .magazine-box {
          @media (min-width: 567px) {
            flex-direction: row-reverse;
          }

          .post-list {
            padding: 30px 0;
            width: 100%;

            @media (min-width: 567px) {
              padding: 0 0 0 30px;
              width: 50%;
            }

            .post-title {
              flex: 1;
              display: flex;
              align-items: center;
              padding: 15px;
              width: 100%;
              color: #4f4f4f;
              border-top: 1px solid ${primary_s5_l90(primaryColor)};

              &:last-of-type {
                border-bottom: 1px solid ${primary_s5_l90(primaryColor)};
              }

              &:focus,
              &:hover,
              &.active {
                color: #fff;
                background-color: ${primaryColor};
              }
            }
          }
        }
      }

      &.variant-3 {
        margin-bottom: 40px;

        .magazine-box {
          .post-list {
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: space-between;
            padding: 0;
            width: 100%;

            @media (min-width: 768px) {
              flex-direction: row;
              margin: 0 -15px;
            }

            .post-title {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;
              width: 100%;
              margin-bottom: 40px;
              color: #4f4f4f;

              @media (min-width: 768px) {
                margin: 0;
                padding: 0 15px;
              }

              .image-title,
              .read-more {
                width: 100%;
              }

              .post-image {
                display: block;
                width: 100%;
                height: 260px;
                margin-bottom: 20px;
              }

              .post-truncate-title {
                font-weight: 600;
                text-align: center;
                text-transform: uppercase;

                @media (min-width: 768px) {
                  text-align: left;
                }
              }

              .read-more {
                margin-top: 20px;
                text-align: center;

                @media (min-width: 768px) {
                  text-align: right;
                }

                svg {
                  margin-left: 10px;
                  color: ${primaryColor};
                }
              }
            }
          }
        }
      }
    `;

    const latestThreePosts = posts.slice(0, 3);

    return (
      <div
        className={`magazine variant-${uiVariantBlogNewsletter}`}
        css={magazineStyle}
      >
        <div className="title">Magazine</div>
        {uiVariantBlogNewsletter === "3" ? (
          <div className="magazine-box">
            <div className="post-list">
              {latestThreePosts.map((post) => {
                return (
                  <Link key={post.id} to={`#${post.id}`} className="post-title">
                    <div className="image-title">
                      <div
                        className="post-image"
                        style={{
                          backgroundImage: `url(${post.featuredImageUrl})`,
                          backgroundColor: primary_light(primaryColor),
                        }}
                      />
                      <div className="post-truncate-title">
                        <TextTruncate line={2} text={post.title} />
                      </div>
                    </div>
                    <div className="read-more">
                      Leggi di più
                      <FaChevronRight />
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="magazine-box">
            <Link to={`#`} className="btn btn-thick btn-primary mobile-btn">
              Leggi di più
            </Link>
            <div className="post-list">
              {posts.map((post) => {
                return (
                  <A
                    key={post.id}
                    className={`post-title ${
                      post.id === selectedPost.id ? "active" : ""
                    }`}
                    href={"#" + post.id}
                    onMouseOver={this.setSelectedPost(post)}
                  >
                    <TextTruncate line={2} text={post.title} />
                  </A>
                );
              })}
            </div>
            <Link
              to={`# `}
              className="post-image"
              style={{
                backgroundImage: `url(${
                  selectedPost.imgUrl || (posts[0] && posts[0].featuredImageUrl)
                })`,
                backgroundColor: primary_light(primaryColor),
              }}
            >
              <Button
                className="btn btn-thick btn-primary desktop-btn"
                disabled
              >
                Leggi di più
              </Button>
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default Magazine;
